<template>
    <div>
        <div class="text-center">
            <h2 class="pt-12 px-5" v-text="$t('FAQ_OTHER_CATEGORIES_NOT_FOUND')"></h2>
            <p class="pb-3" v-text="$t('FAQ_OTHER_CATEGORIES_TRY')"></p>
        </div>

        <div class="flex flex-wrap">
            <div
                v-if="showEmptyBox(notLoggedInCategories)"
                class="faq__empty faq__image background--paper divider--container h-full">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>

            <faq-category-box
                v-for="(category, index) in notLoggedInCategories"
                :category="category"
                :key="index">
            </faq-category-box>

            <div
                v-if="showEmptyBox(notLoggedInCategories)"
                class="faq__empty faq__image background--paper divider--container h-full">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>
        </div>

        <div v-if="isUserLoggedIn" class="flex flex-wrap">
            <div v-if="showEmptyBox(loggedInCategories)"
                 class="faq__empty faq__image background--paper divider--container h-full">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>

            <faq-category-box
                v-for="(category, index) in loggedInCategories"
                :category="category"
                :key="index">
            </faq-category-box>

            <div
                v-if="showEmptyBox(loggedInCategories)"
                class="faq__empty faq__image background--paper divider--container h-full">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
import FaqCategoryBox from '@/components/partials/faq/FaqCategoryBox';

export default {
    name: 'FaqOtherCategories',
    methods: {
        isCurrentRoute(isCurrentRoute, current) {
            if (this.$router.currentRoute.path.includes(current.path)) {
                isCurrentRoute = true;
            }

            return isCurrentRoute;
        },

        showEmptyBox(categories) {
            return categories.reduce(this.isCurrentRoute.bind(this), false);
        },
    },
    computed: {
        isUserLoggedIn() {
            return this.$store.getters['auth/isUserLoggedIn'];
        },
        categories() {
            return this.$store.getters['faq/getCategories'];
        },
        loggedInCategories() {
            return this.$store.getters['faq/getLoggedInCategories'];
        },
        notLoggedInCategories() {
            return this.$store.getters['faq/getNotLoggedInCategories'];
        },
    },
    components: {
        FaqCategoryBox,
    },
};
</script>
